export default __webpack_public_path__ + "static/media/3.4de52556.jpg";